<template>
  <div class="shade-selector">
    <ul class="slider__list">
      <li
        class="slider__item shade-swatch"
        v-for="(item, i) in shades"
        :key="i"
      >
        <input
          class="sr-only"
          type="radio"
          :id="item.ShadeNumber"
          name="selected-shade"
          :checked="item.IsCurrent"
          @change="shadeSelected(item)"
        />
        <label
          :style="[(item.ShadeImage != null && item.ShadeImage.Src != '') ? '' : {'backgroundColor': item.HexCode}]"
          :for="item.ShadeNumber" 
          >
          <img class="lazy" v-if="item.ShadeImage != null && item.ShadeImage.Src != ''"  src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" :data-src="item.ShadeImage.Src" :alt="item.ShadeImage.Alt">
          <span class="sr-only">{{ item.ShadeNumber }} {{ item.ShadeName }}</span>
        </label>
      </li>
    </ul>
    <p id="current-shade" class="heading-sm-em mt-sm">
      {{ shades[0].ShadeNumber }} {{ shades[0].ShadeName }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'ShadeSelector',
  props: {
    shades: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    if (this.shades.length >= 1) {
      let defaultShadeEan = this.shades[0].Ean;
      eventBus.$emit('shade::selected', defaultShadeEan);
    }
  },
  methods: {
    shadeSelected(item) {
      let shadeDescription = item.ShadeNumber + ' ' + item.ShadeName;
      document.getElementById('current-shade').innerText = shadeDescription;
      if (item && item.Tagging) {
        const eventData =
          typeof item.Tagging === 'string'
            ? JSON.parse(item.Tagging)
            : item.Tagging;
        window.dataLayer.push(eventData);
      }
      eventBus.$emit('shade::selected', item.Ean);
    },
  },
};
</script>
<style lang="scss" src="./shade-selector.scss"></style>
